// extracted by mini-css-extract-plugin
export default {"union":"style_union__++ekj"};